<template>
  <div class="app-container" v-if="form">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <!-- <template v-if="activeName === 4 || activeName === 5">
        <div class="title-box"><span class="txt1">处理方案</span></div>
        <el-descriptions>
          <el-descriptions-item label="售后方式">{{form.afterMethod == 1?'退款(零售价)':'换货'}}</el-descriptions-item>
          <el-descriptions-item label="售后来源" v-if="form.afterMethod == 1 && activeName === 4">{{ form.source == 1?'APP用户提交':(form.source == 2?'待认领售后订单':'') }}</el-descriptions-item>
          <el-descriptions-item :label="activeName === 4?'应退金额':'退还金额'" v-if="form.afterMethod == 1">￥{{form.refundMoney}}</el-descriptions-item>
          <el-descriptions-item label="退回账户" v-if="form.afterMethod == 1">零售价</el-descriptions-item>
          <el-descriptions-item label="补差金额" v-if="form.afterMethod == 2">￥{{form.repairMoney}}</el-descriptions-item>
          <el-descriptions-item label="关联订货订单" v-if="form.afterMethod == 2 && activeName === 5">{{form.customerOrderNum}}</el-descriptions-item>
        </el-descriptions>
        <template v-if="form.afterMethod == 2">
          <el-descriptions title="换货商品信息"></el-descriptions>
          <el-table :data="form.exchangeGoodsList" style="width: 100%">
            <el-table-column prop="goodsName" label="换货商品" align="center"></el-table-column>
            <el-table-column prop="goodsCount" label="件数" align="center"></el-table-column>
            <el-table-column prop="batchNumber" label="批次号" align="center"></el-table-column>
            <el-table-column prop="expirationDate" label="有效期" align="center"></el-table-column>
          </el-table>
          <el-descriptions v-if="form.customerAddressPO" class="mt10">
            <el-descriptions-item label="收货地址">{{form.customerAddressPO.province}}{{form.customerAddressPO.city}}{{form.customerAddressPO.district}}{{form.customerAddressPO.detailedAddress}}</el-descriptions-item>
          </el-descriptions>
        </template>
      </template> -->
      <div class="tab-box">
        <span :class="{'active': tabType === 1}" @click="tabType = 1">基础信息</span>
        <span :class="{'active': tabType === 0}" @click="tabType = 0">物流信息</span>
        <span :class="{'active': tabType === 2}" @click="tabType = 2">售后信息</span>
        <span :class="{'active': tabType === 5}" @click="tabType = 5">操作记录</span>
      </div>
      <template v-if="tabType === 1">
        <div class="title-box"><span class="txt1">基础信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="售后编码">{{form.orderNum}}</el-descriptions-item>

          <el-descriptions-item label="售后状态">{{form.state==1?'待审核':(form.state==2?'待寄回商品':(form.state==3?'待收货':(form.state==31?'待处理售后':(form.state==41?'待大区审核':(form.state==42?'待尤总审核':(form.state==4?'待确认':(form.state==5?'已完成':(form.state==6?'申请驳回':'售后驳回'))))))))}}</el-descriptions-item>
          <el-descriptions-item label="申请原因">{{form.applyReason}}</el-descriptions-item>
          <el-descriptions-item label="申请备注">{{form.applyRamark}}</el-descriptions-item>
          <el-descriptions-item label="凭证">
            <div v-if="form.voucherUrl">
              <el-image class="banner-box" v-for="(item,index) in form.voucherUrl && form.voucherUrl.split(',')" :key="index" :src="item" :preview-src-list="[item]"></el-image>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="申请时间">{{form.applyTime}}</el-descriptions-item>
          <el-descriptions-item label="同意申请时间" v-if="activeName === 2 || activeName === 3 || activeName === 4 || activeName === 5 || activeName === 7">{{form.afterTime}}</el-descriptions-item>
          <el-descriptions-item label="寄出时间" v-if="activeName === 3 || activeName === 4 || activeName === 5 || activeName === 7">{{form.deliverTime}}</el-descriptions-item>
          <el-descriptions-item label="完成时间" v-if="activeName === 5">{{form.completeTime}}</el-descriptions-item>
          <template v-if="activeName === 6">
            <el-descriptions-item label="驳回时间">{{form.rejectTime}}</el-descriptions-item>
          </template>
          <template v-if="activeName === 7">
            <el-descriptions-item label="驳回类型"> {{form.rejectState === 1?'平台驳回':(form.rejectState === 2?'未支付':(form.rejectState === 3?'':'未确认'))}}</el-descriptions-item>
            <el-descriptions-item label="售后驳回时间">{{form.rejectTime}}</el-descriptions-item>
          </template>
          <el-descriptions-item label="驳回原因" v-if="activeName === 6 || activeName === 7">{{form.rejectReason}}</el-descriptions-item>
          <el-descriptions-item label="通商云单号">{{form.tongShangYunOrderNum}}</el-descriptions-item>
        </el-descriptions>
        <div class="title-box"><span class="txt1">申请人信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="下单人">{{form.applyName}}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{form.applyPho}}</el-descriptions-item>
          <el-descriptions-item label="所属区域" v-if="form.addr && form.addr.length > 0">
            <span v-for="(item,index) in form.addr" :key="index">{{item.regionName}}</span>
          </el-descriptions-item>
        </el-descriptions>
        <div class="title-box"><span class="txt1">申请人从属关系</span></div>
        <el-descriptions :column="1">
          <el-descriptions-item label="带教老师" v-if="form.technicianInfoLine2 && form.technicianInfoLine2.length">
            <div class="fr1-body">
              <span class="blueColor">{{custBigTechLine}}</span>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="技术线" v-if="form.technicianInfoLine && form.technicianInfoLine.length">
            <div class="fr1-body">
              <span class="blueColor">{{custTechLine}}</span>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="业务线">
            <div class="fr1-body">
              <span class="blueColor">{{custBusinessLine}}</span>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="城市公司">{{form.nameCity}}</el-descriptions-item>
        </el-descriptions>
        <div class="title-box"><span class="txt1">售后商品信息</span></div>
        <el-table :data="form.goodsList" style="width: 100%">
          <el-table-column prop="afterGoodsName" label="商品名称" align="center"></el-table-column>
          <el-table-column prop="afterGoodsCount" label="件数" align="center">
            <template slot-scope="{ row }">
              <span>{{row.afterGoodsCount||row.acceptanceQuantity}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="platformProductName" label="平台匹配商品" align="center"> </el-table-column>
          <el-table-column prop="batchNumber" label="批次号" align="center"> </el-table-column>
          <el-table-column prop="expirationDate" label="有效期" align="center"> </el-table-column> -->
        </el-table>
      </template>
      <template v-else-if="tabType === 0">
        <div class="title-box"><span class="txt1">寄件人信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="寄件人">{{form.applyName}}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{form.applyPho}}</el-descriptions-item>
          <!-- <el-descriptions-item label="寄件地址">{{form.addrProvince}}{{form.addrCity}}{{form.addrArea}}{{form.addrDetail}}</el-descriptions-item> -->
        </el-descriptions>
        <div class="title-box"><span class="txt1">客户寄回商品物流信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="寄出时间">{{form.deliverTime}}</el-descriptions-item>
        </el-descriptions>
        <el-table :data="form.deliverInfo || []" style="width: 100%">
          <el-table-column prop="lable" label="包裹" align="center"></el-table-column>
          <!-- <el-table-column prop="name" label="寄件人" align="center"></el-table-column> -->
          <el-table-column label="快递编号" align="center">
            <template slot-scope="{ row }">
              {{ row.num }}
            </template>
          </el-table-column>
          <el-table-column prop="deliverTime" label="收货时间" align="center"> </el-table-column>
          <el-table-column label="操作" align="center" width="230">
            <template slot-scope="{ row }">
              <el-button type="text" @click="lookLogistics(row)">查看物流</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="title-box" v-if="form.deliverInfoSigned"><span class="txt1">修改后的物流信息</span></div>
     
        <el-table :data="form.deliverInfo || []" style="width: 100%" v-if="form.deliverInfoSigned">
          <el-table-column prop="lable" label="包裹" align="center"></el-table-column>
          <!-- <el-table-column prop="name" label="寄件人" align="center"></el-table-column> -->
            <el-table-column prop="deliverInfoSigned" label="快递编号" align="center"> </el-table-column>
          <el-table-column prop="deliverTimeSigned" label="操作时间" align="center"> </el-table-column>
          <!-- <el-table-column prop="deliverTime" label="操作人" align="center"> </el-table-column> -->
          <el-table-column label="操作" align="center" width="230">
            <template slot-scope="{ row }">
              <el-button type="text" @click="lookLogistics(row)">查看物流</el-button>
            </template>
          </el-table-column>
        </el-table> 
        <template v-if="changeform">
          <div class="title-box"><span class="txt1">换货订单物流信息</span></div>
          <el-descriptions>
            <el-descriptions-item label="收货信息">{{changeform.name}}</el-descriptions-item>
            <el-descriptions-item label="寄出时间">{{changeform.deliverTime}}</el-descriptions-item>
            <el-descriptions-item label="发货时间">{{changeform.sendTime}}</el-descriptions-item>
          </el-descriptions>
          <el-descriptions>
            <el-descriptions-item label="物流信息"></el-descriptions-item>
          </el-descriptions>
          <el-table :data="changeform.deliveryList" style="width: 100%">
            <el-table-column prop="deliveryName" label="包裹" align="center" key="1"></el-table-column>
            <el-table-column prop="deliveryNum" label="快递编号" align="center" key="2"> </el-table-column>
            <el-table-column label="操作" align="center" width="230" key="3">
              <template slot-scope="{ row }">
                <el-button type="text" @click="lookLogistics(row)">查看物流</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </template>
      <template v-else-if="tabType === 2">
        <div class="title-box"><span class="txt1">售后收货信息</span></div>

        <el-descriptions :column="2" class="section-content">
          <el-descriptions-item label="收货员">{{form.signedByName }}</el-descriptions-item>
          <el-descriptions-item label="确认收货时间">{{form.signedTime}}</el-descriptions-item>
        </el-descriptions>

        <!-- 实际收货商品 -->
        <div class="after-sales-section">
          <div class="section-title">
            <span>实际收货商品:</span>
          </div>
          <el-table :data="(form.goodsList || []).filter(item => item.isSign !== false)" style="width: 100%" class="section-content">
            <el-table-column prop="afterGoodsName" label="商品名称" align="center"></el-table-column>
            <el-table-column prop="afterGoodsCount" label="件数" align="center"></el-table-column>
            <el-table-column prop="platformProductName" label="平台匹配商品" align="center"></el-table-column>
            <el-table-column prop="acceptanceQuantity" label="验收数量" align="center"></el-table-column>
            <el-table-column prop="retailPrice" label="零售价" align="center" />
            <el-table-column prop="inBoundQuantity" label="入库信息" align="center" />
            <el-table-column prop="batchNumber" label="批次号" align="center"></el-table-column>
            <el-table-column prop="expirationDate" label="有效期" align="center"></el-table-column>
          </el-table>
          <!-- <div class="table-summary">
            <span>共计: {{getTotalQuantity()}}</span>
            <span>验收数量: {{getTotalAcceptedQuantity()}}</span>
          </div> -->
          <el-descriptions :column="1" class="section-content mt10">
            <el-descriptions-item label="附件">
              <div v-if="form.attachment">
                <div v-for="(item,index) in form.attachment && form.attachment.split(',')" :key="index" class="attachment-item">
                  <!-- 图片文件 -->
                  <el-image v-if="isImageFile(item)" class="banner-box" :src="item" :preview-src-list="getImageList()">
                  </el-image>
                  <!-- 视频文件 -->
                  <video v-else-if="isVideoFile(item)" class="video-box" controls :src="item">
                  </video>
                  <!-- 其他文件类型 -->
                  <div v-else class="file-link">
                    <a :href="item" target="_blank" class="file-download">
                      <i class="el-icon-document"></i>
                      {{ getFileName(item) }}
                    </a>
                  </div>
                </div>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="备注">{{form.remarks}}</el-descriptions-item>
          </el-descriptions>
        </div>

        <template v-if="form.state == 4 || form.state == 5 || form.state == 41 || form.state == 42 || form.state == 31">
          <div class="title-box"><span class="txt1">售后处理信息</span></div>
          <el-descriptions :column="2" class="section-content">
            <el-descriptions-item label="处理人">{{form. solutionByName}}</el-descriptions-item>
            <el-descriptions-item label="售后处理时间">{{form.solutionTime}}</el-descriptions-item>
          </el-descriptions>

          <!-- 售后结果 -->
          <div class="after-sales-section">
            <div class="section-title">
              <span>售后结果:</span>
            </div>
            <el-table :data="(form.goodsList || []).filter(item => item.isSign !== false)" style="width: 100%" class="section-content">
              <el-table-column label="售后商品信息" align="center" width="300">
                <template slot-scope="{row}">
                  <div class="goods-info">
                    <div class="goods-header">
                      <img src="@/assets/gd.png" alt="" class="goods-icon" />
                      <!-- REQ-2026-234328：与本页表格列同口径，产品规格优先、为空回落旧值 -->
                      <span class="goods-name">{{ row.platformProductName }} - {{ row.productSpec || row.spec || '无规格值' }}</span>
                    </div>
                    <div class="goods-details">
                      <div class="detail-row">
                        <span class="detail-label">验收数量:</span>
                        <span class="detail-value quantity">×{{ row.acceptanceQuantity }}</span>
                      </div>
                      <div class="detail-row">
                        <span class="detail-label">批次号:</span>
                        <span class="detail-value">{{ row.batchNumber }}</span>
                      </div>
                      <div class="detail-row">
                        <span class="detail-label">入库信息:</span>
                        <span class="detail-value">{{ row.inBoundQuantity }}</span>
                      </div>
                    </div>
                    <div class="goods-price">
                      <div class="detail-row">
                        <span class="detail-label">商品零售价:</span>
                        <span class="detail-value price">¥{{ row.retailPrice }}</span>
                      </div>
                      <div class="detail-row">
                        <span class="detail-label">有效期:</span>
                        <span class="detail-value">{{ row.expirationDate && row.expirationDate.substring(0,10) }}</span>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="afterSalesMethod" label="售后方式" align="center">
                <template slot-scope="{row}">
                  {{row.afterMethod == 1 ? '退款' : '换货'}}
                </template>
              </el-table-column>
              <el-table-column prop="refundAmount" label="退款金额" align="center">
                <template slot-scope="{row}">
                  <span v-if="row.refundMoney">{{row.refundMoney}}元</span>
                </template>
              </el-table-column>
              <el-table-column prop="afterGoodsName" label="换货商品" align="center">
                <template slot-scope="{row}">
                  <span v-if="row.afterMethod == 2">{{row.exchangeGoodsName || row.afterGoodsName}}</span>
                </template>
              </el-table-column>
              <!-- REQ-2026-234328：只保留这一列，旧「商品规格」列同维度已删；为空回落旧值 -->
              <el-table-column label="产品规格" align="center">
                <template slot-scope="{row}">
                  <span v-if="row.afterMethod == 2">{{row.productSpec || row.spec || '无规格值'}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="afterGoodsCount" label="换货数量" align="center">
                <template slot-scope="{row}">
                  <span v-if="row.afterMethod == 2">{{row.exchangeGoodsCount || row.afterGoodsCount }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="supplementaryPayment" label="补效期款" align="center">
                <template slot-scope="{row}">
                  <span v-if="row.repairMoney">{{row.repairMoney}}元</span>
                </template>
              </el-table-column>
            </el-table>

            <!-- 汇总信息 -->
            <div class="summary-totals">
              <div class="total-item">
                <span class="label">退款总金额:</span>
                <span class="value red-text">{{getTotalRefundAmount()}}元</span>
              </div>
              <div class="total-item">
                <span class="label">换货商品数量:</span>
                <span class="value red-text">{{getTotalExchangeQuantity()}}件</span>
              </div>
              <div class="total-item">
                <span class="label">总补差金额:</span>
                <span class="value red-text">{{getTotalDifferenceAmount()}}元</span>
              </div>
              <div class="total-item">
                <span class="label">退款商品补差金额:</span>
                <span class="value red-text">{{getRefundDifferenceAmount()}}元</span>
              </div>
              <div class="total-item">
                <span class="label">换货商品补差金额:</span>
                <span class="value red-text">{{getExchangeDifferenceAmount()}}元</span>
              </div>
            </div>
          </div>

          <!-- 底部信息 -->
          <div class="after-sales-section">
            <el-descriptions :column="3" class="section-content">
              <el-descriptions-item label="邮费">{{form.freightFee}}</el-descriptions-item>
              <el-descriptions-item label="支付方式">{{form.payType === 1 ? '微信支付' : (form.payType === 2 ? '支付宝支付' : (form.payType === 3 ? '零售价' : '现金'))}}</el-descriptions-item>
              <el-descriptions-item label="收货地址">
                <span v-if="form.customerAddressPO">
                  {{form.customerAddressPO.province}}{{form.customerAddressPO.city}}{{form.customerAddressPO.district}}{{form.customerAddressPO.detailedAddress}}
                </span>
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </template>

        <template v-if="form.isActivityAfter || form.regionalApprovalBy || form.ceoApprovalBy">
          <div class="title-box"><span class="txt1">审核信息</span></div>
          <el-descriptions :column="2" class="section-content">
            <el-descriptions-item label="是否活动商品">{{form.isActivityAfter ? '是' : '否'}}</el-descriptions-item>
            <el-descriptions-item label="大区审核人">{{form.regionalApprovalByName || form.regionalApprovalBy || '-'}}</el-descriptions-item>
            <el-descriptions-item label="大区审核时间">{{form.regionalApprovalTime || '-'}}</el-descriptions-item>
            <el-descriptions-item label="大区审核结果">
              <span v-if="!form.regionalApprovalBy">-</span>
              <el-tag v-else-if="regionalEscalated" type="warning" size="mini">不同意，已上报尤总</el-tag>
              <el-tag v-else type="success" size="mini">同意</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="大区审核备注">{{form.regionalApprovalRemark || '-'}}</el-descriptions-item>
            <el-descriptions-item label="尤总审核人">{{form.ceoApprovalByName || form.ceoApprovalBy || '-'}}</el-descriptions-item>
            <el-descriptions-item label="尤总审核时间">{{form.ceoApprovalTime || '-'}}</el-descriptions-item>
            <el-descriptions-item label="尤总审核备注">{{form.ceoApprovalRemark || '-'}}</el-descriptions-item>
            <el-descriptions-item label="尤总审核附件">
              <div v-if="form.ceoApprovalAttachment">
                <el-image
                  v-for="(item,index) in form.ceoApprovalAttachment.split(',')"
                  :key="index"
                  class="banner-box"
                  :src="item"
                  :preview-src-list="form.ceoApprovalAttachment.split(',')"
                />
              </div>
              <span v-else>-</span>
            </el-descriptions-item>
          </el-descriptions>
        </template>
      </template>
      <template v-else-if="tabType === 5">
        <div class="title-box"><span class="txt1">操作记录</span></div>
        <el-table :data="logList" style="width: 100%">
          <el-table-column prop="createdTime" label="操作时间" align="center" width="180"></el-table-column>
          <el-table-column label="操作人" align="center" width="120">
            <template slot-scope="{ row }">
              {{ row.createdName || '-' }}
            </template>
          </el-table-column>
          <el-table-column label="操作内容" align="center" width="150">
            <template slot-scope="{ row }">
              {{ getLogTitle(row) }}
            </template>
          </el-table-column>
          <el-table-column label="操作详情" align="left" min-width="400">
            <template slot-scope="{ row }">
              <div v-if="row.remarks" class="operation-details">
                <div v-html="formatOperationDetails(row.remarks)"></div>
              </div>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- <pagination v-show="total>0" :total="total" :pageNo.sync="logQuery.page" :pageSize.sync="logQuery.pageSize" @pagination="getLogList" /> -->
      </template>
    </el-card>
    <logistics-details-vue ref="logisticsDetailsVue" />
  </div>
</template>
<script>
import goodsOrderApi from '@/api/order/goodsOrder'
import { accAdd } from '@/utils'
import logisticsDetailsVue from '@/views/common/logisticsDetails.vue';
import sysStepLogApi from '@/api/log/sysStepLog'
export default {
  props: ['rowItem'],
  components: { logisticsDetailsVue },
  data() {
    return {
      activeName: 1,
      tabType: 1,  //1基础信息 0 物流信息 2售后信息
      tableData: [],
      form: null,
      changeform: '',
      logList: [],
      logQuery: {
        pageNo: 1,
        pageSize: 200
      },
      logList: [],
      total: 0
    };
  },
  created() {
    this.activeName = +this.rowItem.activeName
    this.getDetails()
    this.getChangeDetails()
    this.getLogList()
  },
  computed: {
    custBusinessLine() {
      const arr = (this.form.customerLine || []).map(it => it.name + '【' + this.getCLevelLabel(it.clevel) + '】')
      return arr.join(' - ')
    },
    custTechLine() {
      const form = this.form
      const arr = (form.technicianInfoLine || []).map(it => it.realName + '【' + it.levelName + '】')
      const self = form.applyName + '【' + this.getCLevelLabel(form.clevel) + '】'
      return arr.length ? self + ' - ' + arr.join(' - ') : self
    },
    custBigTechLine() {
      const form = this.form
      const arr = (form.technicianInfoLine2 || []).map(it => it.realName + '【' + it.levelName + '】')
      const self = form.applyName + '【' + this.getCLevelLabel(form.clevel) + '】'
      return arr.length ? self + ' - ' + arr.join(' - ') : self
    },
    // 大区点的是"同意"还是"不同意"：两者写入的审批字段与操作日志完全一样(同意→regionalApprove，
    // 不同意→escalateToCeo)，日志行本身区分不了，只能靠单据流向反推。加签尤总即代表不同意，两种表现：
    //   1) 单据还停在 42「待尤总审核」；
    //   2) 尤总已经处理过，且处理时间晚于大区审核时间。
    // 时间比较不能省：售后单可被「撤回平台处理」后重走流程，而 ceo_approval_* 不会清空，
    // 只看 ceoApprovalBy 有没有值会把上一轮的残留当成本轮加签（生产 8287 即为此例：
    // 尤总 8-17 审过后单据被撤回，大区 8-19 重审并同意，却仍带着 8-17 的 ceoApprovalBy）。
    regionalEscalated() {
      if (Number(this.form.state) === 42) return true
      const reg = this.form.regionalApprovalTime
      const ceo = this.form.ceoApprovalTime
      if (!reg || !ceo) return false
      return new Date(String(ceo).replace(/-/g, '/')) > new Date(String(reg).replace(/-/g, '/'))
    },
  },
  methods: {
    getCLevelLabel(cLevel, customerType) {
      const map = { 1: '总监', 2: '营销经理', 3: '大区经理', 4: '地区经理', 5: '县区经理', 6: '研修班', 7: '体验班', 8: '普通人员' }
      if (cLevel && map[cLevel]) return map[cLevel]
      const tMap = { 1: '总监经理', 2: '业务员', 3: '加盟商' }
      return tMap[customerType] || ''
    },
    // 判断是否为图片文件
    isImageFile(url) {
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
      return imageExtensions.some(ext => url.toLowerCase().includes(ext));
    },
    // 判断是否为视频文件
    isVideoFile(url) {
      const videoExtensions = ['.mp4', '.avi', '.mov', '.wmv', '.flv', '.webm'];
      return videoExtensions.some(ext => url.toLowerCase().includes(ext));
    },
    // 获取所有图片文件列表（用于图片预览）
    getImageList() {
      if (!this.form.attachment) return [];
      return this.form.attachment.split(',').filter(item => this.isImageFile(item));
    },
    // 获取文件名
    getFileName(url) {
      return url.split('/').pop();
    },
    // 根据日志内容和审批信息，转换操作日志标题
    getLogTitle(row) {
      if (row.title === '平台已处理' && this.form) {
        // 大区审核：原先无条件返回"同意"，大区明明点了不同意也显示同意。判据见 regionalEscalated
        if (row.createdBy && this.form.regionalApprovalBy && String(row.createdBy) === String(this.form.regionalApprovalBy)) {
          return this.regionalEscalated ? '大区审核不同意，已上报尤总' : '大区审核同意'
        }
        // 尤总审核：ceoApprove不写step_log.remarks，ceoReject才写，用remarks有无区分同意/驳回
        if (row.createdBy && this.form.ceoApprovalBy && String(row.createdBy) === String(this.form.ceoApprovalBy)) {
          return row.remarks ? '尤总审核驳回' : '尤总审核同意'
        }
      }
      return row.title
    },
    getLogList(pagination) {
      // 如果分页组件传递了参数，使用参数中的值，否则使用 logQuery 中的值
      let pageNo = pagination ? pagination.pageNo : this.logQuery.pageNo;
      let pageSize = pagination ? pagination.pageSize : this.logQuery.pageSize;

      // 更新 logQuery 以确保同步
      if (pagination) {
        this.logQuery.pageNo = pagination.pageNo;
        this.logQuery.pageSize = pagination.pageSize;
      }

      sysStepLogApi.fetchList({ type: 1, foreignId: this.rowItem.id, pageNo, pageSize }).then(({ data }) => {
        this.logList = data.list;
        this.total = data.total;
      })
    },
    // 格式化操作详情
    formatOperationDetails(remarks) {
      if (!remarks) return '-';
      
      try {
        const data = JSON.parse(remarks);
        return this.buildDetailHtml(data);
      } catch (e) {
        return remarks;
      }
    },
    // 构建详情HTML - 只展示有值的字段
    buildDetailHtml(data) {
      // 统一的字段映射表
      const fieldMap = {
        id: 'ID',
        attachment: '附件',
        remarks: '备注',
        customerAddressId: '用户地址id',
        expressCode: '快递公司',
        freightFee: '运费',
        payType: '补差支付方式',
        goodsList: '商品信息', 
        afterGoodsName: '售后商品名称',
        afterGoodsCount: '售后商品数量',    
        platformProductId: '平台匹配商品id',
        platformCombineId: '平台匹配商品规格id',
        acceptanceQuantity: '验货数量',
        retailPrice: '零售价',
        inBoundQuantity: '入库数量',
        batchNumber: '批次号',      
       expirationDate: '有效期',
        afterMethod: '售后处理方式',
        refundMoney: '退款金额',
        exchangeGoodsId: '换货商品id',
        exchangeGoodsName: '换货商品名称',
        exchangeCombineId: '换货规格id',
        exchangeGoodsCount: '换货商品数量',
        repairMoney: '补差金额'
      };
      
      let parts = [];
      let goodsListHtml = '';
      
      for (let key in data) {
        if (!data.hasOwnProperty(key)) continue;
        
        const value = data[key];
        
        // 跳过空值、null、undefined
        if (value === null || value === undefined || value === '') continue;
        
        const label = fieldMap[key] || key;
        
        // 处理商品列表
        if (key === 'goodsList' && Array.isArray(value) && value.length > 0) {
          // 定义字段展示顺序
          const goodsFieldOrder = [
            'id',
             'afterGoodsName',
             'platformProductId',
            'platformCombineId',
            'retailPrice',
            'acceptanceQuantity',
          'inBoundQuantity',
            'batchNumber',
            'expirationDate',
            
            'afterGoodsCount',
            'afterMethod',
            'refundMoney',
            'exchangeGoodsId',
            'exchangeGoodsName',
            'exchangeCombineId',
            'exchangeGoodsCount',
            'repairMoney'
          ];
          
          value.forEach((goods, index) => {
            let goodsParts = [];
            
            // 按照指定顺序遍历字段
            goodsFieldOrder.forEach(gKey => {
              if (!goods.hasOwnProperty(gKey)) return;
              
              let gValue = goods[gKey];
              
              // 跳过空值
              if (gValue === null || gValue === undefined || gValue === '') return;
              
              const gLabel = fieldMap[gKey] || gKey;
              
              // 特殊值转换
              if (gKey === 'afterMethod') {
                gValue = gValue === 1 ? '退款(零售价)' : (gValue === 2 ? '换货' : gValue);
              }
              
              goodsParts.push(`${gLabel}: ${gValue}`);
            });
            
            if (goodsParts.length > 0) {
              goodsListHtml += `<div class="goods-line">【商品${index + 1}】${goodsParts.join('；')}</div>`;
            }
          });
        } else if (!Array.isArray(value)) {
          // 处理普通字段
          let displayValue = value;
          
          // 特殊值转换
          if (key === 'payType') {
            displayValue = value === 0 ? '现金支付' : (value === 1 ? '零售价支付' : '-');
          } else if (key === 'expressCode') {
            displayValue = value === 1 ? '顺丰' : (value === 2 ? '京东' : value);
          }
          
          parts.push(`${label}: ${displayValue}`);
        }
      }
      
      let html = '<div class="operation-detail-inline">';
      if (parts.length > 0) {
        html += `<div class="base-info">${parts.join('；')}</div>`;
      }
      if (goodsListHtml) {
        html += goodsListHtml;
      }
      html += '</div>';
      return html;
    },
    getChangeDetails() {
      goodsOrderApi.getExchangeDetail({ id: this.rowItem.id }).then(({ data }) => {
        this.changeform = data;
      })
    },
    // 获取总件数
    getTotalQuantity() {
      if (!this.form.goodsList) return 0;
      return this.form.goodsList.reduce((sum, item) => sum + (item.afterGoodsCount || 0), 0);
    },

    // 获取总验收数量
    getTotalAcceptedQuantity() {
      if (!this.form.goodsList) return 0;
      return this.form.goodsList.reduce((sum, item) => sum + (item.acceptanceQuantity || 0), 0);
    },

    // 获取退款总金额
    getTotalRefundAmount() {
      if (!this.form.goodsList) return 0;
      const result = this.form.goodsList
        .filter(item => item.afterMethod === 1)
        .reduce((sum, item) => accAdd(sum, item.refundMoney || 0), 0);
      return Number(result.toFixed(2));
    },

    // 获取换货总数量
    getTotalExchangeQuantity() {
      if (!this.form.goodsList) return 0;
      return this.form.goodsList
        .filter(item => item.afterMethod === 2)
        .reduce((sum, item) => sum + (item.exchangeGoodsCount || 0), 0);
    },

    // 获取总补差金额
    getTotalDifferenceAmount() {
      if (!this.form.goodsList) return 0;
      const result = this.form.goodsList.reduce((sum, item) => accAdd(sum, item.repairMoney || 0), 0);
      return Number(result.toFixed(2));
    },

    // 获取退款商品补差金额
    getRefundDifferenceAmount() {
      if (!this.form.goodsList) return 0;
      const result = this.form.goodsList
        .filter(item => item.afterMethod === 1)
        .reduce((sum, item) => accAdd(sum, item.repairMoney || 0), 0);
      return Number(result.toFixed(2));
    },

    // 获取换货商品补差金额
    getExchangeDifferenceAmount() {
      if (!this.form.goodsList) return 0;
      const result = this.form.goodsList
        .filter(item => item.afterMethod === 2)
        .reduce((sum, item) => accAdd(sum, item.repairMoney || 0), 0);
      return Number(result.toFixed(2));
    },
    getDetails() {
      goodsOrderApi.getAfterDetail(this.rowItem.id).then(({ data }) => {
        // 确保 deliverInfo 始终是数组
        if (data.deliverInfo && typeof data.deliverInfo === 'string' && data.deliverInfo.trim() !== '') {
          // 如果 deliverInfo 是非空字符串（快递编号），检查是否包含多个以逗号分隔的物流单号
          const logisticsNums = data.deliverInfo.split(',').map(num => num.trim()).filter(num => num)
          // 处理修改后的物流信息，也可能包含多个以逗号分隔的单号
          const signedNums = (data.deliverInfoSigned || '').split(',').map(num => num.trim()).filter(num => num)
          
          // 构建数组，每个物流单号作为一个包裹
          data.deliverInfo = logisticsNums.map((num, index) => ({
            name: data.name, 
            lable: `包裹${index + 1}`, 
            num: num, 
            deliverTime: data.deliverTime,
            deliverInfoSigned: signedNums[index] || '',
            deliverTimeSigned: data.deliverTimeSigned || ''
          }))
        } else if (Array.isArray(data.deliverInfo) && data.deliverInfo.length > 0) {
          // 如果已经是数组，确保每个元素都有必要的字段
          // 同时处理数组中每个元素的 num 字段可能也包含多个逗号分隔的单号
          const processedArray = []
          data.deliverInfo.forEach((item, index) => {
            const numStr = item.num || item.deliverInfo || (typeof item === 'string' ? item : '')
            const signedStr = item.deliverInfoSigned || data.deliverInfoSigned || ''
            
            // 检查是否包含多个逗号分隔的单号
            if (numStr && numStr.includes(',')) {
              const nums = numStr.split(',').map(n => n.trim()).filter(n => n)
              const signedNums = signedStr ? signedStr.split(',').map(n => n.trim()).filter(n => n) : []
              nums.forEach((num, idx) => {
                processedArray.push({
                  name: item.name || data.name,
                  lable: item.lable || `包裹${processedArray.length + 1}`,
                  num: num,
                  deliverTime: item.deliverTime || data.deliverTime,
                  deliverInfoSigned: signedNums[idx] || '',
                  deliverTimeSigned: item.deliverTimeSigned || data.deliverTimeSigned || ''
                })
              })
            } else {
              processedArray.push({
                name: item.name || data.name,
                lable: item.lable || `包裹${processedArray.length + 1}`,
                num: numStr,
                deliverTime: item.deliverTime || data.deliverTime,
                deliverInfoSigned: signedStr,
                deliverTimeSigned: item.deliverTimeSigned || data.deliverTimeSigned || ''
              })
            }
          })
          data.deliverInfo = processedArray
        } else if (data.deliverInfoSigned || data.deliverTime || data.deliverInfo) {
          // 如果有任何物流相关信息，构建数组（即使原始快递编号为空）
          const numStr = (data.deliverInfo && typeof data.deliverInfo === 'string' ? data.deliverInfo : '') || ''
          const signedStr = data.deliverInfoSigned || ''
          
          // 检查是否包含多个逗号分隔的单号
          if (numStr && numStr.includes(',')) {
            const nums = numStr.split(',').map(n => n.trim()).filter(n => n)
            const signedNums = signedStr ? signedStr.split(',').map(n => n.trim()).filter(n => n) : []
            data.deliverInfo = nums.map((num, index) => ({
              name: data.name, 
              lable: `包裹${index + 1}`, 
              num: num,
              deliverTime: data.deliverTime,
              deliverInfoSigned: signedNums[index] || '',
              deliverTimeSigned: data.deliverTimeSigned || ''
            }))
          } else {
            data.deliverInfo = [{ 
              name: data.name, 
              lable: '包裹1', 
              num: numStr,
              deliverTime: data.deliverTime,
              deliverInfoSigned: signedStr,
              deliverTimeSigned: data.deliverTimeSigned || ''
            }]
          }
        } else {
          // 如果不存在，初始化为空数组
          data.deliverInfo = []
        }
        
        data.goodsList && data.goodsList.forEach(item => {
          let find = data.exchangeGoodsList.find(it => it.afterGoodsId === item.id)
          if (find) {
            item.exchangeGoodsCount = find.goodsCount
            item.exchangeGoodsName = find.goodsName
          }
        })
        
        // 先设置 form，然后使用 $set 确保 deliverInfo 是响应式的
        this.form = data;
        // 使用 $set 确保 deliverInfo 数组是响应式的
        this.$set(this.form, 'deliverInfo', data.deliverInfo);
      })
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    },
    lookLogistics(row) {
      let { pho } = this.form;
      let str = pho ? `:${pho.trim().slice(-4)}` : ''
      // 优先使用修改后的物流编号，如果没有则使用原始编号
      const logisticsNum = row.deliverInfoSigned || row.num || ''
      this.$refs.logisticsDetailsVue.handleShow(logisticsNum + str)
    },
  },
};
</script>
<style lang="scss" scoped>
.custom {
  font-size: 14px;
  color: #2e2f3e;
  padding: 20px;
  margin: 10px 0;
  &.bg {
    // border-bottom: 1px solid #CCE2D1
    background-color: #eff8fd;
  }
}
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
.tab-box {
  margin: 20px 0;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-right: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.title-cont {
  padding: 10px 20px;
  .fr3 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .fr3-body {
      width: 33.33%;
      font-size: 14px;
      color: #2e2f3e;
      line-height: 30px;
    }
  }
  .fr1 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .fr1-body {
      width: 100%;
      font-size: 14px;
      color: #2e2f3e;
      line-height: 30px;
    }
  }
}
.blueColor {
  color: #1596cd !important;
}
.banner-box {
  width: 50px;
  height: 50px;
  margin: 2px;
}
// ... existing styles ...

.after-sales-section {
  margin-bottom: 30px;

  .section-title {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    .blue-bar {
      width: 4px;
      height: 16px;
      background: #5dbde7;
      border-radius: 2px;
      margin-right: 8px;
    }

    span {
      font-size: 14px;
    }
  }

  .section-content {
    margin-left: 12px;
  }

  .table-summary {
    margin-top: 10px;
    padding: 10px 0;
    border-top: 1px solid #f0f0f0;

    span {
      margin-right: 20px;
      font-size: 14px;
      color: #666;
    }
  }

  .product-info {
    display: flex;
    align-items: flex-start;

    .product-icon {
      width: 20px;
      height: 20px;
      background: #ff6b35;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 8px;
      margin-top: 2px;

      i {
        color: white;
        font-size: 12px;
      }
    }

    .product-details {
      flex: 1;

      .product-name {
        font-weight: 500;
        margin-bottom: 4px;
      }

      .product-detail-item {
        font-size: 12px;
        color: #666;
        line-height: 1.4;

        &.price {
          color: #ff4757;
        }
      }
    }
  }

  .summary-totals {
    margin-top: 20px;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .total-item {
      display: flex;
      align-items: center;
      margin-right: 20px;

      &:last-child {
        margin-right: 0;
      }

      .label {
        font-size: 14px;
        color: #666;
        margin-right: 8px;
      }

      .value {
        font-size: 14px;
        font-weight: 500;

        &.red-text {
          color: #ff4757;
        }
      }
    }
  }
}
.goods-info {
  width: 100%;
  padding: 5px;
  text-align: left;
  font-size: 12px;

  .goods-header {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    line-height: 24px;
    padding-left: 5px;
    .goods-icon {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }

    .goods-name {
      font-size: 12px;
      color: #333;
      font-weight: normal;
    }
  }

  .detail-row {
    display: flex;
    align-items: center;
    line-height: 1.2;

    .detail-label {
      font-size: 11px;
      color: #666;
    }

    .detail-value {
      font-size: 11px;
      color: #333;

      &.quantity {
        color: #333;
        font-weight: normal;
      }

      &.price {
        color: #ff4949;
        font-weight: normal;
      }
    }
  }
}

.attachment-item {
  display: inline-block;
  margin: 2px;
  vertical-align: top;
  video{
    width: 200px;
    height: 150px;
    border-radius: 4px;
    object-fit: cover;
  }
}

.file-link {
  display: inline-block;
  margin: 2px;
  
  .file-download {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    background: #f5f7fa;
    border-radius: 4px;
    color: #606266;
    text-decoration: none;
    font-size: 12px;
    
    &:hover {
      background: #e4e7ed;
      color: #409eff;
    }
    
    i {
      margin-right: 5px;
      font-size: 14px;
    }
  }
}

// 操作详情样式 - 单行展示
.operation-detail-inline {
  font-size: 13px;
  line-height: 1.8;
  color: #303133;
  
  .base-info {
    margin-bottom: 4px;
  }
  
  .goods-line {
    margin-top: 4px;
    padding-left: 10px;
    color: #606266;
  }
}
</style>
